"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledPopupOverlay = exports.PopupWrapperContainer = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _slateReact = require("slate-react");
var _keycodes = require("../../../constants/keycodes");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TextPopupWrapper = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var editor = _ref.editor,
    element = _ref.element,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    children = _ref.children;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    positionX = _useState2[0],
    setPositionX = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    positionY = _useState4[0],
    setPositionY = _useState4[1];
  var nodeRef = (0, _react.useRef)();
  var editorRef = (0, _react.useRef)();
  var handleKeyDown = function handleKeyDown(e) {
    if (isOpen && e.keyCode === _keycodes.ESC) {
      onClose();
    }
  };
  var hideModalOverlay = function hideModalOverlay(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.target === event.currentTarget) {
      onClose();
    }
  };
  var updatePosition = function updatePosition() {
    var nodeRefCurrent = nodeRef.current;
    var editorRefCurrent = editorRef.current;
    if (nodeRefCurrent && editorRefCurrent) {
      var editorRect = editorRefCurrent.getBoundingClientRect();
      var nodeRect = nodeRefCurrent.getBoundingClientRect();
      var positionLeft = nodeRect.left - editorRect.left;
      var positionTop = nodeRect.top - editorRect.top + nodeRect.height;
      setPositionX(positionLeft);
      setPositionY(positionTop);
    }
  };
  (0, _react.useEffect)(function () {
    nodeRef.current = _slateReact.ReactEditor.toDOMNode(editor, element);
    editorRef.current = document && document.getElementById(editor.id);
    document.addEventListener('keydown', handleKeyDown, false);
    return function () {
      document.removeEventListener('keydown', handleKeyDown, false);
    };
  }, []);
  (0, _react.useEffect)(function () {
    updatePosition();
  }, [isOpen]);
  if (!isOpen) return null;
  return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledPopupOverlay, {
    onClick: hideModalOverlay
  }), /*#__PURE__*/_react["default"].createElement(PopupWrapperContainer, {
    positionX: positionX,
    positionY: positionY
  }, children)), editorRef.current);
});
TextPopupWrapper.propTypes = {
  editor: _propTypes["default"].objectOf(_slateReact.ReactEditor).isRequired,
  element: _propTypes["default"].shape({
    url: _propTypes["default"].string
  }).isRequired,
  isOpen: _propTypes["default"].bool.isRequired,
  onClose: _propTypes["default"].func.isRequired,
  children: _propTypes["default"].arrayOf(_propTypes["default"].element).isRequired
};
var PopupWrapperContainer = exports.PopupWrapperContainer = _styledComponents["default"].div.withConfig({
  displayName: "TextPopupWrapper__PopupWrapperContainer",
  componentId: "sc-efw9rg-0"
})(["position:absolute;left:", "px;top:", "px;z-index:20;margin-top:10px;::after{content:\"\";position:absolute;top:-7px;left:18px;width:0;height:0;border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid white;}"], function (props) {
  return props.positionX ? props.positionX : 0;
}, function (props) {
  return props.positionY ? props.positionY : 0;
});
var StyledPopupOverlay = exports.StyledPopupOverlay = _styledComponents["default"].div.withConfig({
  displayName: "TextPopupWrapper__StyledPopupOverlay",
  componentId: "sc-efw9rg-1"
})(["display:flex;width:100%;height:100%;position:fixed;top:0;left:0;overflow:auto;z-index:19;"]);
var _default = exports["default"] = TextPopupWrapper;